"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT = void 0;

var _slateEditBlockquote = _interopRequireDefault(require("slate-edit-blockquote"));

var _blocks = require("@canner/slate-constant/lib/blocks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable new-cap */


var DEFAULT = {
  type: _blocks.BLOCKQUOTE,
  typeDefault: _blocks.PARAGRAPH
};
exports.DEFAULT = DEFAULT;

var _default = function _default(change) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT;
  var options = Object.assign({}, DEFAULT, opt);
  var newChange;
  var utils = (0, _slateEditBlockquote.default)(options).utils;
  var changes = (0, _slateEditBlockquote.default)(options).changes;

  if (utils.isSelectionInBlockquote(change.value)) {
    newChange = changes.unwrapBlockquote(change);
  } else {
    newChange = changes.wrapInBlockquote(change);
  }

  return newChange;
};

exports.default = _default;